// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #4f46e5;
  --primary-dark: #4338ca;
  --primary-light: #e0e7ff;

  /* Token display colors */
  --token-bg-inner: #1a1a1a;
  --token-bg-outer: #2a2a2a;
  --token-border: #404040;
  --token-text: #ffffff;
  --token-text-muted: #6b7280;
}

/* Mobile layout fixes */
@media (max-width: 640px) {
  /* Prevent horizontal overflow caused by long flex rows */
  html,
  body {
    width: 100%;
    overflow-x: hidden;
  }

  /* Header container wraps and avoids pushing layout horizontally */
  header .container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* Brand + theme toggle row: allow shrink */
  header .container > .flex.items-center.space-x-4 {
    flex: 1 1 auto;
    min-width: 0; /* allow text to truncate instead of overflow */
  }

  /* API key controls layout: stack on small screens */
  #api-key-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: flex-start;
  }

  #api-key-input {
    flex: 1 1 160px; /* grow but has a sane min width */
    min-width: 0; /* allow shrinking within container */
  }

  #save-api-key,
  #clear-api-key {
    flex: 0 0 auto; /* keep intrinsic size but wrap to next line if needed */
    white-space: nowrap;
  }
}

/* The header's two rows use Tailwind's \`space-x-4\`, but that utility is never
   emitted: Tailwind's content globs scan \`src/**\` + root \`index.html\`, not the
   generator's static \`public/generator/index.html\`, and \`space-x-4\` appears
   nowhere in the scanned sources. Without it the token pill sits flush against
   the profile button (0px gap). Restore the intended horizontal spacing with
   explicit CSS scoped to the header rows. */
header .container > .flex.items-center.space-x-4 {
  gap: 1rem;
}

body {
  font-family: 'Inter', sans-serif;
  background-color: #f9fafb;
}

input[type='range'] {
  -webkit-appearance: none;
  height: 0.5rem;
  background: #e5e7eb;
  border-radius: 0.25rem;
  outline: none;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background: var(--primary);
  cursor: pointer;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
}

input[type='range']::-webkit-slider-thumb:hover {
  background: var(--primary-dark);
  transform: scale(1.1);
}

#notification {
  /* Above .modal (9999) so sign-in errors show over the open sign-in modal */
  z-index: 10000;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.param-group {
  transition: all 0.3s ease;
}

button:focus {
  outline: 2px solid var(--primary-light);
  outline-offset: 2px;
}

button:active {
  transform: scale(0.98);
}

/* Tab Styles */
.tab-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tab-navigation {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  background-color: white;
  overflow-x: auto;
}

.tab-button {
  display: inline-flex;
  align-items: center;
  padding: 12px 16px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  color: #6b7280;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.tab-button:hover {
  color: var(--primary);
}

.tab-button.active {
  color: var(--primary);
  border-bottom-color: var(--primary);
}

.tab-content {
  display: none;
  padding: 20px 0;
  flex-grow: 1;
}

.tab-content.active {
  display: block;
}

/* Dark Mode Styles */
.dark body {
  background-color: #111827; /* gray-900 */
  color: #e5e7eb; /* gray-200 - Brighter default text */
}

.dark header,
.dark footer,
.dark .bg-white {
  background-color: #1f2937; /* gray-800 */
  border-color: #374151; /* gray-700 */
}

.dark h1,
.dark .text-indigo-600 {
  color: #818cf8; /* indigo-400 */
}

.dark a.text-indigo-600:hover,
.dark a.text-indigo-800:hover {
  color: #a5b4fc; /* indigo-300 */
}

.dark input[type='password'],
.dark input[type='text'],
.dark input[type='number'],
.dark select,
.dark textarea {
  background-color: #374151; /* gray-700 */
  border-color: #4b5563; /* gray-600 */
  color: #f3f4f6; /* gray-100 - Brighter input text */
}

.dark input::-moz-placeholder, .dark textarea::-moz-placeholder {
  color: #9ca3af; /* gray-400 */
}

.dark input::placeholder,
.dark textarea::placeholder {
  color: #9ca3af; /* gray-400 */
}

.dark input:focus,
.dark select:focus,
.dark textarea:focus {
  border-color: #6366f1; /* indigo-500 */
  --tw-ring-color: #6366f1; /* indigo-500 */
}

.dark button {
  /* Adjust default button colors if needed, or rely on specific classes */
}

.dark .bg-indigo-600 {
  background-color: #4f46e5; /* indigo-600 - keep same or adjust */
}

.dark .hover\\:bg-indigo-700:hover {
  background-color: #4338ca; /* indigo-700 - keep same or adjust */
}

.dark .bg-red-600 {
  background-color: #dc2626; /* red-600 */
}

.dark .hover\\:bg-red-700:hover {
  background-color: #b91c1c; /* red-700 */
}

.dark .text-white {
  color: #ffffff;
}

.dark .text-gray-500,
.dark label /* Target labels specifically */ {
  color: #d1d5db; /* gray-300 - Make labels brighter */
}

.dark .border-gray-200 {
  border-color: #374151; /* gray-700 */
}

.dark .border-gray-300 {
  border-color: #4b5563; /* gray-600 */
}

.dark .shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.15); /* Slightly darker shadow */
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow);
}

/* Tab Navigation Dark */
.dark .tab-navigation {
  background-color: #1f2937; /* gray-800 */
  border-bottom-color: #374151; /* gray-700 */
}

.dark .tab-button {
  color: #d1d5db; /* gray-300 - Brighter inactive tab text */
}

.dark .tab-button:hover {
  color: #a5b4fc; /* indigo-300 */
}

.dark .tab-button.active {
  color: #818cf8; /* indigo-400 */
  border-bottom-color: #818cf8; /* indigo-400 */
}

/* Notification Dark */
.dark #notification {
  /* Keep colors as they are for visibility, or adjust if needed */
}

/* Input Range Dark */
.dark input[type='range'] {
  background: #4b5563; /* gray-600 */
}

.dark input[type='range']::-webkit-slider-thumb {
  background: #818cf8; /* indigo-400 */
}

.dark input[type='range']::-webkit-slider-thumb:hover {
  background: #a5b4fc; /* indigo-300 */
}

/* Modal Styles - Required for auth modals */
.modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal.hide {
  display: none !important;
}

.modal-content {
  background-color: #fff;
  margin: auto;
  padding: 0;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.dark .modal-content {
  background-color: #1f2937;
  color: #e5e7eb;
}

/* Token Tooltip - Radix-style overlay */
.token-tooltip-wrapper {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.15s ease-out,
    visibility 0.15s ease-out;
}

/* Show tooltip on button hover */
.token-tooltip-trigger:hover .token-tooltip-wrapper {
  opacity: 1;
  visibility: visible;
}

.token-tooltip {
  animation: tooltipSlideDown 0.15s ease-out;
}

@keyframes tooltipSlideDown {
  from {
    transform: translateY(-4px);
  }
  to {
    transform: translateY(0);
  }
}

.token-tooltip-content {
  background: #18181b;
  color: #fafafa;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.4;
  box-shadow:
    0 10px 38px -10px rgba(0, 0, 0, 0.35),
    0 10px 20px -15px rgba(0, 0, 0, 0.2),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  min-width: 280px;
  max-width: 320px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  white-space: normal;
  opacity: 1 !important;
}

.token-tooltip-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #fbbf24;
}

.token-tooltip-arrow {
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 4px solid #18181b;
}

/* Dark mode adjustments (already dark by default) */
.dark .token-tooltip-content {
  background: #18181b;
  color: #fafafa;
  box-shadow:
    0 10px 38px -10px rgba(0, 0, 0, 0.5),
    0 10px 20px -15px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1);
}

.dark .token-tooltip-arrow {
  border-top-color: #18181b;
}

/* Video Generation Progress Bar */
.video-rendering-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.video-progress-container {
  position: relative;
  width: 100%;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
}

.video-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #4f46e5, #7c3aed, #4f46e5);
  background-size: 200% 100%;
  border-radius: 4px;
  transition: width 0.1s ease-out;
  animation: shimmer 2s infinite linear;
}

.video-progress-stripes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 8px,
    rgba(255, 255, 255, 0.1) 8px,
    rgba(255, 255, 255, 0.1) 16px
  );
  animation: barbershop 1s infinite linear;
}

.video-progress-text {
  font-size: 12px;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes barbershop {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 32px 0;
  }
}

/* Generator Tab Progress Bar (for Replicate models) */
.generator-rendering-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.generator-progress-container {
  position: relative;
  width: 100%;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
}

.generator-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #4f46e5, #7c3aed, #4f46e5);
  background-size: 200% 100%;
  border-radius: 4px;
  transition: width 0.1s ease-out;
  animation: shimmer 2s infinite linear;
}

.generator-progress-stripes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 8px,
    rgba(255, 255, 255, 0.1) 8px,
    rgba(255, 255, 255, 0.1) 16px
  );
  animation: barbershop 1s infinite linear;
}

.generator-progress-text {
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
/* Tier buttons: Splat tab quality (Basic/High/Max) and Image tab output
   resolution (2K/4K, #1887). Colors live here rather than as Tailwind
   utilities so the .dark theme actually covers them. */
.splat-tier-btn,
.output-tier-btn {
  border-color: #d1d5db; /* gray-300 */
  color: #374151; /* gray-700 */
}

.splat-tier-btn:hover,
.output-tier-btn:hover {
  background-color: #f9fafb; /* gray-50 */
}

.splat-tier-btn.selected,
.output-tier-btn.selected {
  border-color: #4f46e5; /* indigo-600 */
  background-color: #eef2ff; /* indigo-50 */
  color: #4338ca; /* indigo-700 */
}

.dark .splat-tier-btn,
.dark .output-tier-btn {
  border-color: #4b5563; /* gray-600 */
  color: #e5e7eb; /* gray-200 — readable on the dark panel */
}

.dark .splat-tier-btn:hover,
.dark .output-tier-btn:hover {
  background-color: #374151; /* gray-700 */
}

.dark .splat-tier-btn.selected,
.dark .output-tier-btn.selected {
  border-color: #818cf8; /* indigo-400 */
  background-color: rgba(99, 102, 241, 0.25); /* indigo-500 @ 25% */
  color: #c7d2fe; /* indigo-200 */
}
`, "",{"version":3,"sources":["webpack://./src/generator/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;;EAExB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,yDAAyD;EACzD;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA,kEAAkE;EAClE;IACE,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,YAAY,EAAE,+CAA+C;EAC/D;;EAEA,oDAAoD;EACpD;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,eAAe,EAAE,kCAAkC;IACnD,YAAY,EAAE,qCAAqC;EACrD;;EAEA;;IAEE,cAAc,EAAE,wDAAwD;IACxE,mBAAmB;EACrB;AACF;;AAEA;;;;;4CAK4C;AAC5C;EACE,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,2EAA2E;EAC3E,cAAc;EACd;;qBAEmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB,EAAE,aAAa;EACxC,cAAc,EAAE,qCAAqC;AACvD;;AAEA;;;EAGE,yBAAyB,EAAE,aAAa;EACxC,qBAAqB,EAAE,aAAa;AACtC;;AAEA;;EAEE,cAAc,EAAE,eAAe;AACjC;;AAEA;;EAEE,cAAc,EAAE,eAAe;AACjC;;AAEA;;;;;EAKE,yBAAyB,EAAE,aAAa;EACxC,qBAAqB,EAAE,aAAa;EACpC,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EAEE,cAAc,EAAE,aAAa;AAC/B;;AAHA;;EAEE,cAAc,EAAE,aAAa;AAC/B;;AAEA;;;EAGE,qBAAqB,EAAE,eAAe;EACtC,wBAAwB,EAAE,eAAe;AAC3C;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA;EACE,yBAAyB,EAAE,YAAY;AACzC;;AAEA;EACE,yBAAyB,EAAE,YAAY;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc,EAAE,oCAAoC;AACtD;;AAEA;EACE,qBAAqB,EAAE,aAAa;AACtC;;AAEA;EACE,qBAAqB,EAAE,aAAa;AACtC;;AAEA;EACE,0CAA0C,EAAE,2BAA2B;EACvE;;oBAEkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB,EAAE,aAAa;EACxC,4BAA4B,EAAE,aAAa;AAC7C;;AAEA;EACE,cAAc,EAAE,0CAA0C;AAC5D;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,4BAA4B,EAAE,eAAe;AAC/C;;AAEA,sBAAsB;AACtB;EACE,gEAAgE;AAClE;;AAEA,qBAAqB;AACrB;EACE,mBAAmB,EAAE,aAAa;AACpC;;AAEA;EACE,mBAAmB,EAAE,eAAe;AACtC;;AAEA;EACE,mBAAmB,EAAE,eAAe;AACtC;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB;;6BAE2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;;;sCAGoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;EACnB,cAAc;EACd;;;sCAGoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,6DAA6D;EAC7D,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,6DAA6D;EAC7D,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;AACA;;uDAEuD;AACvD;;EAEE,qBAAqB,EAAE,aAAa;EACpC,cAAc,EAAE,aAAa;AAC/B;;AAEA;;EAEE,yBAAyB,EAAE,YAAY;AACzC;;AAEA;;EAEE,qBAAqB,EAAE,eAAe;EACtC,yBAAyB,EAAE,cAAc;EACzC,cAAc,EAAE,eAAe;AACjC;;AAEA;;EAEE,qBAAqB,EAAE,aAAa;EACpC,cAAc,EAAE,0CAA0C;AAC5D;;AAEA;;EAEE,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;;EAEE,qBAAqB,EAAE,eAAe;EACtC,0CAA0C,EAAE,qBAAqB;EACjE,cAAc,EAAE,eAAe;AACjC","sourcesContent":[":root {\n  --primary: #4f46e5;\n  --primary-dark: #4338ca;\n  --primary-light: #e0e7ff;\n\n  /* Token display colors */\n  --token-bg-inner: #1a1a1a;\n  --token-bg-outer: #2a2a2a;\n  --token-border: #404040;\n  --token-text: #ffffff;\n  --token-text-muted: #6b7280;\n}\n\n/* Mobile layout fixes */\n@media (max-width: 640px) {\n  /* Prevent horizontal overflow caused by long flex rows */\n  html,\n  body {\n    width: 100%;\n    overflow-x: hidden;\n  }\n\n  /* Header container wraps and avoids pushing layout horizontally */\n  header .container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  /* Brand + theme toggle row: allow shrink */\n  header .container > .flex.items-center.space-x-4 {\n    flex: 1 1 auto;\n    min-width: 0; /* allow text to truncate instead of overflow */\n  }\n\n  /* API key controls layout: stack on small screens */\n  #api-key-container {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    justify-content: flex-start;\n  }\n\n  #api-key-input {\n    flex: 1 1 160px; /* grow but has a sane min width */\n    min-width: 0; /* allow shrinking within container */\n  }\n\n  #save-api-key,\n  #clear-api-key {\n    flex: 0 0 auto; /* keep intrinsic size but wrap to next line if needed */\n    white-space: nowrap;\n  }\n}\n\n/* The header's two rows use Tailwind's `space-x-4`, but that utility is never\n   emitted: Tailwind's content globs scan `src/**` + root `index.html`, not the\n   generator's static `public/generator/index.html`, and `space-x-4` appears\n   nowhere in the scanned sources. Without it the token pill sits flush against\n   the profile button (0px gap). Restore the intended horizontal spacing with\n   explicit CSS scoped to the header rows. */\nheader .container > .flex.items-center.space-x-4 {\n  gap: 1rem;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background-color: #f9fafb;\n}\n\ninput[type='range'] {\n  -webkit-appearance: none;\n  height: 0.5rem;\n  background: #e5e7eb;\n  border-radius: 0.25rem;\n  outline: none;\n}\n\ninput[type='range']::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 1.25rem;\n  height: 1.25rem;\n  border-radius: 50%;\n  background: var(--primary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\ninput[type='range']::-webkit-slider-thumb:hover {\n  background: var(--primary-dark);\n  transform: scale(1.1);\n}\n\n#notification {\n  /* Above .modal (9999) so sign-in errors show over the open sign-in modal */\n  z-index: 10000;\n  transition:\n    transform 0.3s ease,\n    opacity 0.3s ease;\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.param-group {\n  transition: all 0.3s ease;\n}\n\nbutton:focus {\n  outline: 2px solid var(--primary-light);\n  outline-offset: 2px;\n}\n\nbutton:active {\n  transform: scale(0.98);\n}\n\n/* Tab Styles */\n.tab-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.tab-navigation {\n  display: flex;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: white;\n  overflow-x: auto;\n}\n\n.tab-button {\n  display: inline-flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: #6b7280;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.tab-button:hover {\n  color: var(--primary);\n}\n\n.tab-button.active {\n  color: var(--primary);\n  border-bottom-color: var(--primary);\n}\n\n.tab-content {\n  display: none;\n  padding: 20px 0;\n  flex-grow: 1;\n}\n\n.tab-content.active {\n  display: block;\n}\n\n/* Dark Mode Styles */\n.dark body {\n  background-color: #111827; /* gray-900 */\n  color: #e5e7eb; /* gray-200 - Brighter default text */\n}\n\n.dark header,\n.dark footer,\n.dark .bg-white {\n  background-color: #1f2937; /* gray-800 */\n  border-color: #374151; /* gray-700 */\n}\n\n.dark h1,\n.dark .text-indigo-600 {\n  color: #818cf8; /* indigo-400 */\n}\n\n.dark a.text-indigo-600:hover,\n.dark a.text-indigo-800:hover {\n  color: #a5b4fc; /* indigo-300 */\n}\n\n.dark input[type='password'],\n.dark input[type='text'],\n.dark input[type='number'],\n.dark select,\n.dark textarea {\n  background-color: #374151; /* gray-700 */\n  border-color: #4b5563; /* gray-600 */\n  color: #f3f4f6; /* gray-100 - Brighter input text */\n}\n\n.dark input::placeholder,\n.dark textarea::placeholder {\n  color: #9ca3af; /* gray-400 */\n}\n\n.dark input:focus,\n.dark select:focus,\n.dark textarea:focus {\n  border-color: #6366f1; /* indigo-500 */\n  --tw-ring-color: #6366f1; /* indigo-500 */\n}\n\n.dark button {\n  /* Adjust default button colors if needed, or rely on specific classes */\n}\n\n.dark .bg-indigo-600 {\n  background-color: #4f46e5; /* indigo-600 - keep same or adjust */\n}\n\n.dark .hover\\:bg-indigo-700:hover {\n  background-color: #4338ca; /* indigo-700 - keep same or adjust */\n}\n\n.dark .bg-red-600 {\n  background-color: #dc2626; /* red-600 */\n}\n\n.dark .hover\\:bg-red-700:hover {\n  background-color: #b91c1c; /* red-700 */\n}\n\n.dark .text-white {\n  color: #ffffff;\n}\n\n.dark .text-gray-500,\n.dark label /* Target labels specifically */ {\n  color: #d1d5db; /* gray-300 - Make labels brighter */\n}\n\n.dark .border-gray-200 {\n  border-color: #374151; /* gray-700 */\n}\n\n.dark .border-gray-300 {\n  border-color: #4b5563; /* gray-600 */\n}\n\n.dark .shadow-sm {\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.15); /* Slightly darker shadow */\n  box-shadow:\n    var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),\n    var(--tw-shadow);\n}\n\n/* Tab Navigation Dark */\n.dark .tab-navigation {\n  background-color: #1f2937; /* gray-800 */\n  border-bottom-color: #374151; /* gray-700 */\n}\n\n.dark .tab-button {\n  color: #d1d5db; /* gray-300 - Brighter inactive tab text */\n}\n\n.dark .tab-button:hover {\n  color: #a5b4fc; /* indigo-300 */\n}\n\n.dark .tab-button.active {\n  color: #818cf8; /* indigo-400 */\n  border-bottom-color: #818cf8; /* indigo-400 */\n}\n\n/* Notification Dark */\n.dark #notification {\n  /* Keep colors as they are for visibility, or adjust if needed */\n}\n\n/* Input Range Dark */\n.dark input[type='range'] {\n  background: #4b5563; /* gray-600 */\n}\n\n.dark input[type='range']::-webkit-slider-thumb {\n  background: #818cf8; /* indigo-400 */\n}\n\n.dark input[type='range']::-webkit-slider-thumb:hover {\n  background: #a5b4fc; /* indigo-300 */\n}\n\n/* Modal Styles - Required for auth modals */\n.modal {\n  position: fixed;\n  z-index: 9999;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal.hide {\n  display: none !important;\n}\n\n.modal-content {\n  background-color: #fff;\n  margin: auto;\n  padding: 0;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.dark .modal-content {\n  background-color: #1f2937;\n  color: #e5e7eb;\n}\n\n/* Token Tooltip - Radix-style overlay */\n.token-tooltip-wrapper {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 50;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.15s ease-out,\n    visibility 0.15s ease-out;\n}\n\n/* Show tooltip on button hover */\n.token-tooltip-trigger:hover .token-tooltip-wrapper {\n  opacity: 1;\n  visibility: visible;\n}\n\n.token-tooltip {\n  animation: tooltipSlideDown 0.15s ease-out;\n}\n\n@keyframes tooltipSlideDown {\n  from {\n    transform: translateY(-4px);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n.token-tooltip-content {\n  background: #18181b;\n  color: #fafafa;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.4;\n  box-shadow:\n    0 10px 38px -10px rgba(0, 0, 0, 0.35),\n    0 10px 20px -15px rgba(0, 0, 0, 0.2),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n  min-width: 280px;\n  max-width: 320px;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  white-space: normal;\n  opacity: 1 !important;\n}\n\n.token-tooltip-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: #fbbf24;\n}\n\n.token-tooltip-arrow {\n  position: absolute;\n  bottom: -4px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 4px solid #18181b;\n}\n\n/* Dark mode adjustments (already dark by default) */\n.dark .token-tooltip-content {\n  background: #18181b;\n  color: #fafafa;\n  box-shadow:\n    0 10px 38px -10px rgba(0, 0, 0, 0.5),\n    0 10px 20px -15px rgba(0, 0, 0, 0.3),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n\n.dark .token-tooltip-arrow {\n  border-top-color: #18181b;\n}\n\n/* Video Generation Progress Bar */\n.video-rendering-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n}\n\n.video-progress-container {\n  position: relative;\n  width: 100%;\n  height: 8px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.video-progress-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: linear-gradient(90deg, #4f46e5, #7c3aed, #4f46e5);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  transition: width 0.1s ease-out;\n  animation: shimmer 2s infinite linear;\n}\n\n.video-progress-stripes {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: repeating-linear-gradient(\n    45deg,\n    transparent,\n    transparent 8px,\n    rgba(255, 255, 255, 0.1) 8px,\n    rgba(255, 255, 255, 0.1) 16px\n  );\n  animation: barbershop 1s infinite linear;\n}\n\n.video-progress-text {\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes barbershop {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 32px 0;\n  }\n}\n\n/* Generator Tab Progress Bar (for Replicate models) */\n.generator-rendering-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n}\n\n.generator-progress-container {\n  position: relative;\n  width: 100%;\n  height: 8px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.generator-progress-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: linear-gradient(90deg, #4f46e5, #7c3aed, #4f46e5);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  transition: width 0.1s ease-out;\n  animation: shimmer 2s infinite linear;\n}\n\n.generator-progress-stripes {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: repeating-linear-gradient(\n    45deg,\n    transparent,\n    transparent 8px,\n    rgba(255, 255, 255, 0.1) 8px,\n    rgba(255, 255, 255, 0.1) 16px\n  );\n  animation: barbershop 1s infinite linear;\n}\n\n.generator-progress-text {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4b5563;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n/* Tier buttons: Splat tab quality (Basic/High/Max) and Image tab output\n   resolution (2K/4K, #1887). Colors live here rather than as Tailwind\n   utilities so the .dark theme actually covers them. */\n.splat-tier-btn,\n.output-tier-btn {\n  border-color: #d1d5db; /* gray-300 */\n  color: #374151; /* gray-700 */\n}\n\n.splat-tier-btn:hover,\n.output-tier-btn:hover {\n  background-color: #f9fafb; /* gray-50 */\n}\n\n.splat-tier-btn.selected,\n.output-tier-btn.selected {\n  border-color: #4f46e5; /* indigo-600 */\n  background-color: #eef2ff; /* indigo-50 */\n  color: #4338ca; /* indigo-700 */\n}\n\n.dark .splat-tier-btn,\n.dark .output-tier-btn {\n  border-color: #4b5563; /* gray-600 */\n  color: #e5e7eb; /* gray-200 — readable on the dark panel */\n}\n\n.dark .splat-tier-btn:hover,\n.dark .output-tier-btn:hover {\n  background-color: #374151; /* gray-700 */\n}\n\n.dark .splat-tier-btn.selected,\n.dark .output-tier-btn.selected {\n  border-color: #818cf8; /* indigo-400 */\n  background-color: rgba(99, 102, 241, 0.25); /* indigo-500 @ 25% */\n  color: #c7d2fe; /* indigo-200 */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
